import { Component, Input } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ShippingDirection } from '@app/core/constants/enums';
import { RcmStatusStepperService } from '@app/rcm/rcm-stepper/rcm-status-stepper.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'aar-rcm-shipping-header',
  templateUrl: './rcm-shipping-header.component.html',
  styleUrls: ['./rcm-shipping-header.component.scss']
})
export class RcmShippingHeaderComponent {
  @Input('shippingStatus') shippingStatus: string;
  @Input('dateShipped') dateShipped;
  @Input('dateDelivered') dateDelivered;
  @Input('shippingLogo') shippingLogo = '';
  @Input('urlNumber') urlNumber = '';
  @Input('trackingNumber') trackingNumber = '';
  @Input('trackingLink') trackingLink = '';
  @Input('shippingCarrier') shippingCarrier : number = null;
  @Input('address') address;
  @Input('directionId') directionId;
  @Input('sequence') sequence;
  @Input('shippingReference') shippingReference;
  @Input('id') id = null;
  @Input('shippingId') shippingId;
  @Input('isPreventFeedUpdate') isPreventFeedUpdate;
  @Input('repairOrderNumber') repairOrderNumber;
  @Input('repairOrderLineNumber') repairOrderLineNumber;
  @Input('directShip') set SetDirectShip(value) {
    this.directShip = value;
  };
  @Input('shippingStage') shippingStage:string;
  @Input('panel') panel: MatExpansionPanel;

  direction: ShippingDirection;
  directShip: boolean;
  directShipSubscription: Subscription;
  newShippingRecordText:string= 'New Shipping Record';
  
  onOpenClick():void{
    this.panel.open();
  }
}